module.exports = __webpack_public_path__ + "static/media/password-recovery-img.6542ddd2.svg";